<template>
  <footer>{{label}}</footer>
</template>

<script>
export default {
  data() {
    return {
      label: process.env.VUE_APP_FooterLabel
    };
  }
};
</script>

<style scoped>
footer {
    margin-top: 50px;
  text-align: center;
}
</style>
